import type { AssignmentLine } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';

/** Buyer-facing part number for clipboard copy (AS400 / GIITEM key). */
export function getAssignmentLinePartNumber(
  line: AssignmentLine,
): string | null {
  const sku = line.productSku?.trim();
  if (sku) return sku;
  const name = line.productName?.trim();
  return name || null;
}
